import { Alert, AlertTitle, Box, Chip, Stack, Typography } from '@mui/material';
import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import useURLPaginate from '../../hooks/useURLPaginate';
import PAGINATION from './constants/pagination';
import { useLocalization } from '../../providers/LocalizationProvider';
import getFieldFromSchemaByName from '../../helpers/getFieldFromSchemaByName';

const SearchParams = forwardRef(
  (
    {
      schema,
      valueFormatter = undefined,
      preProcessSearchValues = args => args,
      resultsFound,
    },
    ref,
  ) => {
    const { filters } = useURLPaginate(PAGINATION);
    let processedParams = null;
    const { formatMessage } = useLocalization();

    if (!filters || Object.keys(filters).length === 0) {
      return null;
    }

    processedParams = preProcessSearchValues(filters);

    return (
      <Box ref={ref}>
        <Alert variant="outlined" severity="info">
          <AlertTitle>
            {resultsFound && resultsFound > 0 ? (
              <FormattedMessage
                id="YOUR_SEARCH_RETURNED_COUNT_RESULTS"
                defaultMessage="Your search returned {count} results."
                values={{ count: resultsFound }}
              />
            ) : (
              <FormattedMessage
                id="YOUR_SEARCH_DID_NOT_RETURN_ANY_RESULTS"
                defaultMessage="Your search did not return any results."
              />
            )}
          </AlertTitle>
          <Box mt={2}>
            {Object.entries(processedParams).map(([key, value]) => {
              const fieldFound = getFieldFromSchemaByName(schema, key);
              const displayValue = valueFormatter
                ? (valueFormatter({ name: fieldFound?.name, value }) ?? value)
                : value;
              const label = (
                <Stack gap={0.5} direction="row" alignItems="center">
                  <Typography
                    variant="subtitle2"
                    color="primary"
                    component="span">
                    {fieldFound
                      ? formatMessage({
                          id: fieldFound?.label?.localeId,
                          defaultMessage: fieldFound?.label?.defaultMessage,
                        })
                      : key}
                  </Typography>
                  <Typography variant="subtitle2" component="span">
                    :
                  </Typography>
                  <Typography variant="body2" component="span">
                    {displayValue}
                  </Typography>
                </Stack>
              );
              return (
                <Chip
                  variant="outlined"
                  key={key}
                  sx={{ mr: 1 }}
                  label={label}
                />
              );
            })}
          </Box>
        </Alert>
      </Box>
    );
  },
);

export default SearchParams;
